import type { ThemePayload } from "../schemas/Theme";
import { Colors } from "./colors";
import { isDarkTheme } from "./isDarkTheme";

export function themeEditorBackground(theme: ThemePayload) {
  return isDarkTheme(theme) ? Colors.Neutral0Alpha08 : Colors.PrimaryAlpha08;
}
